module.exports = __webpack_public_path__ + "img/paper_download.b597490b.svg";